module.exports = __webpack_public_path__ + "img/Study.6a98d0c3.png";